
import { S3_BUCKET, S3_REGION } from '@/api';
import BotForm from '@/components/bot/BotForm.vue';
import AppButton from '@/components/ui/AppButton.vue';
import AppModal from '@/components/ui/AppModal.vue';
import AppTextarea from '@/components/ui/AppTextarea.vue';
import {
  WeddingEventImageCaptionSettings,
  WeddingEventImageCommentSettings,
} from '@/types/wedding';
import { WeddingEvent, WeddingEventImage, WeddingEventImageComment } from 'ignite360-core';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Comment from './Comment.vue';
import CommentButton from './CommentButton.vue';
import ImageView from './ImageView.vue';
import LikeButton from './LikeButton.vue';
import ShareButton from './ShareButton.vue';
import WeddingEventImageCaptionForm from './WeddingEventImageCaptionForm.vue';
import WeddingEventImageCommentForm from './WeddingEventImageCommentForm.vue';
@Component({
  name: 'wedding-event-image-modal',
  components: {
    BotForm,
    AppModal,
    AppTextarea,
    AppButton,
    WeddingEventImageCommentForm,
    LikeButton,
    CommentButton,
    ShareButton,
    Comment,
    WeddingEventImageCaptionForm,
    ImageView,
  },
})
export default class WeddingEventImageModal extends Vue {
  @Prop({ required: true, type: Boolean, default: false })
  readonly show!: boolean;

  @Prop({ type: Object, default: null })
  readonly currentImage!: WeddingEventImage | null;

  @Prop({ type: Array, default: () => [] })
  readonly allImages!: WeddingEventImage[];

  @Prop({ type: Object, required: true })
  readonly event!: WeddingEvent;

  @Prop({ type: String, required: true })
  readonly botId!: string;

  @Prop({ type: String, required: true })
  readonly userSessionId!: string;

  @Prop({ type: Boolean, required: false, default: false })
  readonly isAdmin!: boolean;

  loading = false;

  editCaptionMode = false;

  async toggleLike() {
    this.$emit('toggle-like', this.currentImage);
  }

  commentForm: WeddingEventImageCommentSettings = {
    name: '',
    comment: '',
  };

  captionForm: WeddingEventImageCaptionSettings = {
    title: '',
  };

  isPublic = false;

  comments: WeddingEventImageComment[] = [];

  get currentImageIndex(): number {
    return this.currentImage
      ? this.allImages.findIndex((img) => img.id === this.currentImage?.id)
      : -1;
  }

  get sortedComments(): WeddingEventImageComment[] {
    return this.comments.sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    );
  }

  get canNavigatePrevious(): boolean {
    return this.currentImageIndex > 0;
  }

  get canNavigateNext(): boolean {
    return this.currentImageIndex < this.allImages.length - 1;
  }

  navigatePrevious(): void {
    if (this.canNavigatePrevious) {
      const newIndex = this.currentImageIndex - 1;
      const newImage = this.allImages[newIndex];
      this.$emit('update:currentImage', newImage);
      // this.loadComments();
    }
  }

  navigateNext(): void {
    if (this.canNavigateNext) {
      const newIndex = this.currentImageIndex + 1;
      const newImage = this.allImages[newIndex];
      this.$emit('update:currentImage', newImage);
    }
  }

  get canUpdateCaption(): boolean {
    return this.currentImage?.userSessionId === this.userSessionId;
  }

  handleClose(value: boolean): void {
    this.$emit('update:show', value);
  }

  @Watch('currentImage')
  onCurrentImageChange() {
    this.commentForm.name = localStorage.getItem('wedding-event-image-comment-name') || '';
    // this.loadComments();
    this.captionForm.title = this.currentImage?.title || '';
    this.preloadNeighbours();
  }

  // load the previous and next image in the background, so navigating shows them instantly
  preloadNeighbours() {
    if (!this.show || this.currentImageIndex < 0) return;
    [this.allImages[this.currentImageIndex - 1], this.allImages[this.currentImageIndex + 1]]
      .filter((image) => image && !['mp4', 'mov', 'avi', 'webm'].includes(image.extension))
      .forEach((image) => {
        new Image().src = `https://${S3_BUCKET}.s3.${S3_REGION}.amazonaws.com/bots/${this.event.bot.id}/wedding/events/${this.event.id}/images/${image.id}.${image.extension}`;
      });
  }

  async submitComment(commentForm: WeddingEventImageCommentSettings): Promise<void> {
    this.$emit('submit-comment', commentForm);
    this.commentForm = { name: commentForm.name, comment: '' };
  }

  async submitCaption(captionForm: WeddingEventImageCaptionSettings): Promise<void> {
    this.$emit('submit-caption', captionForm);
    this.captionForm = { title: (captionForm.title || '').trim() };
  }

  cancelCaption(): void {
    this.editCaptionMode = false;
    this.captionForm = { title: this.currentImage?.title || '' };
  }
}
